export default __webpack_public_path__ + "b739ab04747cf8e3325a748352a3d3cb.ttf";